import { TextFieldProps } from '@mui/material';
import { FC } from 'react';
import { useInterventionLocationsQuery } from '../../generated/graphql';
import useConcession from '../../hooks/useConcession';
import SelectAutocompleteDataField from '../SelectAutocompleteDataField/SelectAutocompleteDataField';

interface InterventionLocationProps {
    name?: string
    label?: string
    textFieldProps?: TextFieldProps
    disabled?: boolean
    limit?: number
}

const InterventionLocation: FC<InterventionLocationProps> = props => {
    const {
        name = "interventionLocation",
        label = "Localização na Infraestrutura",
        textFieldProps = { variant: "standard" },
        disabled,
        limit = 999
    } = props
    const concession = useConcession()
    return (
        <SelectAutocompleteDataField
            name={name}
            label={label}
            query={useInterventionLocationsQuery}
            textFieldProps={textFieldProps}
            disabled={disabled}
            queryPaging={{
                limit
            }}
            queryFilter={{
                concession: {
                    id: {
                        eq: concession?.id
                    }
                }
            }}

        />
    )
}

export default InterventionLocation
